import request from '@/utils/request'

// 查询CMS文章举报分页
export function pageReport(query) {
  return request({
    url: '/article/report/page',
    method: 'get',
    params: query
  })
}

// 删除CMS文章举报
export function delReport(data) {
  return request({
    url: '/article/report/delete',
    method: 'post',
    data: data
  })
}

// 查询CMS文章举报详情
export function getReport(id) {
  return request({
    url: '/article/report/detail?id=' + id,
    method: 'get'
  })
}

